import { useEffect } from "react";
import { useNavigate } from "react-router";

type RedirectProps = {
  to: string;
  when: boolean;
};

const useRedirect = ({ to, when }: RedirectProps) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (when) navigate(to, { replace: true });
  }, [when, navigate, to]);
};

export default useRedirect;
